import useFetchList from '../../../elements/Hooks/useFetchList'
import useModalData from '../../../elements/Hooks/useModalData'
import React  from 'react'
import { GroupsApi } from '../../../api/Groups'
import Groups from '../../../components/Main/Group/Groups'

function GroupsCont() {
  const { list, fetching, fetch } = useFetchList(() => GroupsApi.list())

  const {
    visible,
    modalType,
    object: group,
    setObject: setGroup,
    submitting,
    submit,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    update,
  } = useModalData(GroupsApi.create, GroupsApi.update, GroupsApi.remove, fetch)


  return (
    <Groups
      {...{
        list,
        fetching,
        fetch,
        visible,
        modalType,
        group,
        setGroup,
        submitting,
        submit,
        removing,
        remove,
        formRef,
        onShow,
        onCancel,
        update,
      }}
    />
  )
}

export default GroupsCont
